import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { APP_CONFIG } from '@application/config';
import { LiveRatingResponse } from '../entities/academy.model';

/**
 * Rate a live event (upsert, one per event+person). 🔑 identity from token (no `PersonId`).
 * Pre-validates the score (integer 1–5) before the call; ⚠ the server still returns 400 otherwise.
 */
@Injectable({ providedIn: 'root' })
export class LiveRatingsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(APP_CONFIG).apiUrl.academy_service;

  /** `POST /LiveRatings/{id}/rate` — query `score` (1–5, required), `comment?` (≤2000). */
  public rate(
    liveEventId: string,
    score: number,
    comment?: string,
  ): Observable<LiveRatingResponse> {
    if (!Number.isInteger(score) || score < 1 || score > 5) {
      return throwError(
        () => new Error('Invalid score; expected an integer between 1 and 5'),
      );
    }
    let params = new HttpParams().set('score', String(score));
    if (comment) params = params.set('comment', comment);
    return this.http.post<LiveRatingResponse>(
      `${this.baseUrl}/LiveRatings/${encodeURIComponent(liveEventId)}/rate`,
      {},
      { params, withCredentials: true },
    );
  }
}
